<template>
    <div id="app">
      <GraphicsTemplate />
    </div>
  </template>
  
  <script>
  import GraphicsTemplate from '../share/GraphicsTemplate.vue'
  
  export default {
    name: 'App',
    components: {
        GraphicsTemplate,
    },
  };
  </script>
  
  <style>

  </style>